import { render, staticRenderFns } from "./GrupoProdutoRoute.vue?vue&type=template&id=01b9b868"
import script from "./GrupoProdutoRoute.vue?vue&type=script&lang=js"
export * from "./GrupoProdutoRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports